import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const EndStoryDialog = ({ open, onReplay, onButtonMid, onGoBack }) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(20, 20, 20, 0.9)", // Dark semi-transparent background
          color: "white",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0px 4px 20px rgba(255, 255, 255, 0.2)", // Soft glow
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.8)", // Dark overlay
        }
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "1.8rem",
          fontWeight: "bold",
          textAlign: "center",
          paddingBottom: "10px",
        }}
      >
        🎉 Story Completed!
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.1rem",
            textAlign: "center",
            opacity: 0.9,
            marginBottom: "20px"
          }}
        >
          What would you like to do next?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Column on mobile, row on larger screens
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
        }}
      >
        <Button
          onClick={onReplay}
          sx={{
            backgroundColor: "#1976d2", // Blue color
            color: "white",
            fontSize: "1rem",
            padding: "8px 20px",
            borderRadius: "8px",
            textTransform: "none",
            width: { xs: "100%", sm: "auto" }, // Full width on mobile, auto on larger screens
            "&:hover": {
              backgroundColor: "#1565c0",
              boxShadow: "0px 0px 10px rgba(25, 118, 210, 0.6)"
            }
          }}
          variant="contained"
        >
          🔄 Replay
        </Button>

        <Button
          onClick={onButtonMid}
          sx={{
            backgroundColor: "#FFC107", // Yellow color
            color: "white",
            fontSize: "1rem",
            padding: "8px 20px",
            borderRadius: "8px",
            textTransform: "none",
            width: { xs: "100%", sm: "auto" }, // Full width on mobile, auto on larger screens
            "&:hover": {
              backgroundColor: "#c5b911",
              boxShadow: "0px 0px 10px rgba(214, 202, 28, 0.6)"
            }
          }}
          variant="contained"
        >
          ✉️ Feedback
        </Button>

        <Button
          onClick={onGoBack}
          sx={{
            backgroundColor: "#f50057", // Pinkish-red
            color: "white",
            fontSize: "1rem",
            padding: "8px 20px",
            borderRadius: "8px",
            textTransform: "none",
            width: { xs: "100%", sm: "auto" }, // Full width on mobile, auto on larger screens
            "&:hover": {
              backgroundColor: "#c51162",
              boxShadow: "0px 0px 10px rgba(245, 0, 87, 0.6)"
            }
          }}
          variant="contained"
        >
          🚀 Explore More
        </Button>
      </DialogActions>

    </Dialog>
  );
};

export default EndStoryDialog;